import React from "react";
import {Card} from "../modules/AttendanceReports";

export function AttendanceCardPage (props) {
  return (
    <Card {...props} />
  );
}
